import { useState } from "react";
import { useReportAccidentQuery } from "../reportRoadAccidents/hooks/useReportAccidentQuery";
import { useLegalProcessDocumentCommand } from "./hooks/useLegalProcessDocumentCommand";
import SelectSearch from "../../common/components/SelectSearch";
import Button from "../../common/components/Button";

function RegisterDocuments() {
  const {
    legalProcessDocument,
    handleChangeLegalProcessDocument,
    errors,
    createLegalProcessDocument,
    loading,
  } = useLegalProcessDocumentCommand();
  const [search, setSearch] = useState(legalProcessDocument.accident || "");
  const { reportAccidents } = useReportAccidentQuery({ search, limit: 10 });

  const handleChangeFile = (file) => {
    if (file) {
      handleChangeLegalProcessDocument({
        name: "files",
        value: [...legalProcessDocument.files, file],
      });
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    createLegalProcessDocument().then(() => {
      setSearch("");
    })
  };

  return (
    <main className="container p-4">
      <header className="d-flex justify-content-between align-items-center mb-4 px-3 py-2 border-bottom">
        <h1 className="h2 m-0 fw-bold">
          Registrar documentos de procesos juridicos
        </h1>
      </header>

      <section className="shadow w-100 d-flex flex-column">
        <div className="d-flex gap-3">
          <div className="w-100">
            <p>
              Formulario de registro de documentos legales relacionados con
              siniestros.
            </p>

            <form onSubmit={handleSubmit} className="d-flex flex-column gap-3">
              <SelectSearch
                name="accident"
                label="Siniestros"
                placeholder="Selecciona un siniestro"
                options={reportAccidents.map((accident) => ({
                  value: accident.id,
                  label: `${accident.dateAccident} - ${accident.id} - ${accident.namePersonInvolved} - ${accident.vehiclePlate}`,
                }))}
                value={legalProcessDocument.accident}
                onSelect={handleChangeLegalProcessDocument}
                onSearch={(text) => setSearch(text)}
                error={errors.errors.accident}
              />

              <div className="row row-cols-1 row-cols-md-4 g-3">
                {Array.from({
                  length: legalProcessDocument.files.length + 1,
                }).map((_, index) => (
                  <div className="col" key={index}>
                    <input
                      type="file"
                      className="form-control"
                      onChange={(e) => handleChangeFile(e.target.files[0])}
                      id={`fileInput-${index}`}
                      accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
                    />
                  </div>
                ))}
              </div>

              <Button type="submit" loading={loading}>
                Registrar Documento
              </Button>
            </form>
          </div>
        </div>
      </section>
    </main>
  );
}

export default RegisterDocuments;
